export default "__VITE_ASSET__BC36EIIr__"